import React, { useEffect, useState } from "react";
import { ASSETS } from "../../utils/config";
import {
  Container,
  Title,
  Description,
  LearnMoreButton,
  MoreContent,
  StatsContainer,
  Stat,
  StatText,
  StatIcon,
} from "./styles";
import Tooltip from "@mui/material/Tooltip";
import { removeHtmlTags } from "../../utils/helpers";
import useScreenSize from "../../hooks/useScreenSize";
import ContentEditable from "react-contenteditable";

function WheelInfo({ data = {} }) {
  const { description } = data;

  const [showMore, setShowMore] = useState(false);
  const [truncatedDescription, setTruncatedDescription] = useState("");
  const { isMobileLandscape } = useScreenSize();

  const handleLearnMoreClick = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  const cleanedDescription = removeHtmlTags(description).trim();

  useEffect(() => {
    const truncated =
      cleanedDescription.length > 450 && !showMore
        ? `${cleanedDescription.substring(0, 450)}...`
        : cleanedDescription;

    // Detect word with 50 or more characters without spaces
    const hasLongWordWithoutSpaces = /\S{50,}/.test(truncated);
    if (hasLongWordWithoutSpaces) {
      setTruncatedDescription(
        truncated.replace(/(\S{50,})/g, "$1\u200B") // Add zero-width space for breaking
      );
    } else {
      setTruncatedDescription(truncated);
    }
  }, [cleanedDescription, showMore]);

  return (
    <Container show={showMore}>
      <Title>Wheel Description</Title>
      <Description style={{ wordBreak: "break-word" }}>
        <ContentEditable html={description || ""} disabled />

        {/* {cleanedDescription.length > 200 && (
          <div>
            <LearnMoreButton onClick={handleLearnMoreClick}>
              {showMore ? "Show Less" : "Show More"}
            </LearnMoreButton>
          </div>
        )} */}
      </Description>

      {/* <StatsContainer>
        <Tooltip
          title={`Cloned ${data?.cloneCount || 0} times`}
          placement="top"
        >
          <Stat>
            <StatIcon src={ASSETS.segmentEditor.CloneIcon} alt="clone icon" />
            <StatText>{data?.cloneCount || 0}</StatText>
          </Stat>
        </Tooltip>
        <Tooltip
          title={`Shared ${data?.shareCount || 0} times`}
          placement="top"
        >
          <Stat>
            <StatIcon src={ASSETS.segmentEditor.ShareIcon} alt="share icon" />
            <StatText>{data?.shareCount || 0}</StatText>
          </Stat>
        </Tooltip>
        <Tooltip title={`Liked ${data?.cloneCount || 0} times`} placement="top">
          <Stat>
            <StatIcon src={ASSETS.segmentEditor.LikeIcon} alt="like icon" />
            <StatText>{data?.cloneCount || 0}</StatText>
          </Stat>
        </Tooltip>
      </StatsContainer> */}
    </Container>
  );
}

export default WheelInfo;
